import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useTechRunNowResultsLogic } from 'shared-modules/services/hooks/builder';
import { handleRedirect } from '../../../../redux/actions';
import RunSuccess from '../RunAutoTradeComponents/RunSuccess';

const TechAddToPortfolioSuccess = ({ isOpen, closeModal, orderName, fullErrorText }) => {
  const dispatch = useDispatch();

  const openHomeScreen = useCallback(() => {
    closeModal();
    dispatch(handleRedirect({ url: '/home', isInner: true }));
  }, [closeModal, dispatch]);

  const runNowResultsLogic = useTechRunNowResultsLogic({ orderName, closeModal, fullErrorText });

  return (
    <RunSuccess
      isOpen={isOpen}
      closeModal={closeModal}
      runNowResultsLogic={runNowResultsLogic}
      onClickButton={openHomeScreen}
    />
  );
};

TechAddToPortfolioSuccess.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  orderName: PropTypes.string.isRequired,
  fullErrorText: PropTypes.shape({}).isRequired,
};

export default memo(TechAddToPortfolioSuccess);
